import React, { useState, useEffect, useMemo } from 'react'
import classNames from 'classnames';
import OutsideClickHandler from 'react-outside-click-handler'
import { DatePicker, getDefaultDateOptions, RELATIVE_TIME_RANGE_OPTIONS } from './DatePicker'
import { DownCevron2 } from 'images/common';
import { isMatch, isEmpty } from 'lodash'

const TimeRangeMenu = ({
  selectedOption = {},
  defaultDate = {},
  menuOffset,
  onOptionSelected = (val) => null,
  onClose = (val) => null
}) => {

  return (
    <OutsideClickHandler onOutsideClick={onClose}>
      <div
        className={classNames('dashboard-time-range-menu', menuOffset && `dashboard-time-range-menu--${menuOffset}`)}
        onClick={event => event.stopPropagation()}
      >
        <DatePicker
          defaultDateOption={defaultDate}
          hasDashboardDefaultOption={false}
          selectedDate={selectedOption}
          onApplySelectedDate={(timeRange) => {
            if (isEmpty(timeRange)) {
              return onOptionSelected(defaultDate)
            }
            return onOptionSelected(timeRange)
          }}
        />
      </div>
    </OutsideClickHandler>
  )
}

export const FilterDate = ({
  label = '',
  selectedDate = {},
  defaultDate = {},
  menuOffset,
  onChange = (val) => null,
  disabled = false
}) => {
  const defaultDateOption = useMemo(() => getDefaultDate())

  const [currentSelectedOption, setCurrentSelectedOption] = useState(isEmpty(selectedDate) ? defaultDateOption : selectedDate)
  const [currentLabel, setCurrentLabel] = useState(label ? label : defaultDateOption?.label)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useEffect(() => {
    if (!isEmpty(selectedDate) &&
      (selectedDate?.start !== currentSelectedOption?.start ||
        selectedDate?.end !== currentSelectedOption?.end)
    ) {
      setCurrentSelectedOption(selectedDate)
    }
  }, [selectedDate])

  useEffect(() => {
    if (label && label !== currentLabel) {
      setCurrentLabel(label)
    }
  }, [label])

  const handleToggleMenu = () => {
    setIsMenuOpen(prevState => !prevState)
  }

  const handleOnSelection = (newSelectedDate) => {
    onChange(newSelectedDate)
  }

  return (
    <div className={`filters-bar__item dashboard-filter-date-button`}>
      <button
        type='button'
        className={classNames('filters-bar__button', {
          'filters-bar__button_disabled': disabled,
          'label-color': true,
        })}
        onClick={handleToggleMenu}
      >
        {currentLabel}
        <div
          className="dashboard-filter__icon"
        >
          <DownCevron2 />
        </div>
      </button>

      {isMenuOpen &&
        <TimeRangeMenu
          menuOffset={menuOffset}
          selectedOption={currentSelectedOption}
          defaultDate={isEmpty(defaultDate) ? defaultDateOption : defaultDate}
          onOptionSelected={val => {
            handleOnSelection(val)
            handleToggleMenu()
          }}
          onClose={handleToggleMenu}
        />
      }
    </div>
  )
}

const getDefaultDate = () => {
  return getDefaultDateOptions(false, RELATIVE_TIME_RANGE_OPTIONS).find(date => date.label === 'Last 1 month') || {}
}